import CalendarModel from 'uplisting-frontend/models/calendar';
import PropertyModel from 'uplisting-frontend/models/property';

export enum BookingRequestStatus {
  approved = 'approved',
  pending = 'pending',
  rejected = 'rejected',
}

export interface IBookingRequestSchema {
  checkIn: Date;
  checkOut: Date;
  guestName: string;
  numberOfGuests: number;
  status: BookingRequestStatus;
  channel: string;

  property: PropertyModel;
  calendar: CalendarModel;
}
